import { onReady } from './util/onReady';

/*
Function that tries to break a URL into multiple lines in a readable way.
*/
export function formatUrl(url: string) {
    // Split the URL into an array to distinguish double slashes from single slashes
    const urlParts = url.split('//');
    // Format the strings on either side of double slashes separately
    const formatted = urlParts
        .map(
            (part) =>
                part
                    .replace(/(?<after>:)/giu, '$1<wbr>')
                    // Before a single slash, tilde, period, comma, hyphen, underline, question mark, number sign, or percent symbol
                    .replace(/(?<before>[/~.,\-_?#%])/giu, '<wbr>$1')
                    // Before and after an equals sign or ampersand
                    .replace(/(?<beforeAndAfter>[=&])/giu, '<wbr>$1<wbr>'),
            // Reconnect the strings with word break opportunities after double slashes
        )
        .join('//<wbr>');
    return formatted;
}

function addBreakpointsToUrls() {
    const urls = document.querySelectorAll('.bio > a');
    for (const url of urls) {
        const urlText = url.textContent;
        if (!urlText) continue;
        url.textContent = '';
        url.innerHTML = formatUrl(urlText);
    }
}

function showMoreElements(target: HTMLButtonElement, elementList: HTMLElement) {
    if (!elementList) return;

    const hiddenElements = elementList.querySelectorAll('.pubElement.hideTheElement');
    const hiddenLength = hiddenElements.length;
    const numberOfElementsToShow = hiddenLength > 5 ? 5 : hiddenLength;

    for (let i = 0; i < numberOfElementsToShow; i++) {
        hiddenElements[i].classList.remove('hideTheElement');
    }
    updateButtonText(target, hiddenLength - numberOfElementsToShow);
}

function updateButtonText(button: HTMLButtonElement, numberOfElementsStillHidden: number) {
    if (!button) return;

    if (numberOfElementsStillHidden === 0) {
        button.setAttribute('aria-hidden', 'true');
        button.classList.add('hideTheElement');
    } else {
        button.querySelectorAll('._jsNbToShow')[0].innerHTML = String(
            numberOfElementsStillHidden > 5 ? 5 : numberOfElementsStillHidden,
        );
        button.querySelectorAll('._jsNbLeft')[0].innerHTML = String(numberOfElementsStillHidden);
    }
}

function toggleElement(targetId: string) {
    const element = document.getElementById(targetId);
    if (!element) return;
    element.classList.toggle('hideTheElement');
}

function init() {
    const loadMoreAcademicExperience = document.getElementById('loadMoreAcademicExperience');
    const loadMoreWorkExperience = document.getElementById('loadMoreWorkExperience');

    if (loadMoreAcademicExperience) {
        loadMoreAcademicExperience.addEventListener('click', () => {
            const targetId = loadMoreAcademicExperience.getAttribute('aria-controls');
            if (!targetId) return;
            toggleElement(targetId);
        });
    }

    if (loadMoreWorkExperience) {
        loadMoreWorkExperience.addEventListener('click', () => {
            const targetId = loadMoreWorkExperience.getAttribute('aria-controls');
            if (!targetId) return;
            toggleElement(targetId);
        });
    }

    const cristinContainer = document.querySelector('.jsCristinPublications');

    if (!cristinContainer) return;

    const showMoreButtons = cristinContainer.querySelectorAll<HTMLButtonElement>('._jsShowMorePublications');
    const showSummaryButtons = cristinContainer.querySelectorAll<HTMLButtonElement>('._jsShowSummary');

    showMoreButtons.forEach((button) => {
        button.addEventListener(
            'click',
            () => {
                const targetId = button.getAttribute('aria-controls');
                if (!targetId) return;
                const elementList = document.getElementById(targetId);
                if (!elementList) return;
                showMoreElements(button, elementList);
            },
            { passive: true },
        );
    });

    showSummaryButtons.forEach((button) => {
        button.addEventListener(
            'click',
            () => {
                const targetId = button.getAttribute('aria-controls');
                if (!targetId) return;
                toggleElement(targetId);
            },
            { passive: true },
        );
    });

    addBreakpointsToUrls();
}

onReady(() => {
    init();
});
